import { create } from 'apisauce'

export const auth = create({
  baseURL: process.env.REACT_APP_BASE_URL,
})
